import * as z from 'zod';
import * as expenseTypeFunctions from './functions';

export const ExpenseTypeSchema = z.object({
    'id': z.number(),
    'is_active': z.boolean(),
    'name': z.string(),
    'group': z.string(),
    'accounting': z.string()
});

export const ExpenseTypePartialSchema = ExpenseTypeSchema.partial();
export type ExpenseTypePartial = z.infer<typeof ExpenseTypePartialSchema>;
export type ExpenseType = z.infer<typeof ExpenseTypeSchema>;

export function newExpenseType(data: unknown) {
    if (data === null || data === undefined) {
        throw new Error('Payload can\'t be null or undefined.');
    }

    if (typeof data !== 'object') {
        throw new Error('Payload has to be an object');
    }

    return {
        ...ExpenseTypeSchema.parse({...data}),
        ...expenseTypeFunctions
    };
}

export function parseExpenseType(data: any, partial = false) {
    if (!partial) {
        return {
            ...ExpenseTypeSchema.parse(data),
            ...expenseTypeFunctions
        };
    }
    else if (data === null || data === undefined) {
        throw new Error('Payload can\'t be null or undefined.');
    }
    else if (typeof data !== 'object') {
        throw new Error('Payload has to be an object');
    }
    else if (Object.keys(data).length === 0) {
        throw new Error('Payload Object can\'t be null');
    }
    else {
        return {
            ...ExpenseTypePartialSchema.parse(data),
            ...expenseTypeFunctions
        };
    }
}
